// Correspondance classe Tailwind -> couleur hexadécimale réelle, pour les
// endroits qui ont besoin de la VRAIE couleur (halo, glow d'icône) et pas
// seulement de la classe utilitaire. Ajouter une entrée à chaque nouvelle
// couleur de module utilisée sur l'accueil (cf. ModuleIcon.jsx).
export const GLOW = {
  "bg-emerald-500": "#10b981",
  "bg-blue-500": "#3b82f6",
  "bg-red-500": "#ef4444",
  "bg-amber-500": "#f59e0b",
  "bg-sky-500": "#0ea5e9",
};

// Même couleurs, en triplet RGB « r g b » (pas de virgule) : c'est le format
// que consomment les variables CSS `rgb(var(--tint) / .35)` des tuiles
// « style B » (StatWidget, RandomMissingCard) — mêmes clés que GLOW.
export const TINT = {
  "bg-emerald-500": "16 185 129",
  "bg-blue-500": "59 130 246",
  "bg-red-500": "239 68 68",
  "bg-amber-500": "245 158 11",
  "bg-sky-500": "14 165 233",
};
